export const AlternativeQuiz = [
  {
    slug: 'welcome',
    components: [
      {
        component: 'variation',
        slug: 'welcome',
        variations: [
          {
            name: 'first',
            components: [
              {
                component: 'title',
                title: 'Having problems <br> with your iPhone?',
                isSmall: true,
              },
              {
                component: 'image',
                src: '/alternative/alternative1.png',
                width: 200,
                height: 200,
                alt: 'Image',
              },
            ],
          },
          {
            name: 'second',
            components: [
              {
                component: 'title',
                title: 'Is your iPhone acting <br> strange lately?',
                isSmall: true,
              },
              {
                component: 'image',
                src: '/alternative/alternative2.png',
                width: 200,
                height: 200,
                alt: 'Image',
              },
            ],
          },
          {
            name: 'third',
            components: [
              {
                component: 'title',
                title: 'Seeing unusual <br> pop-ups or alerts?',
                isSmall: true,
              },
              {
                component: 'image',
                src: '/alternative/alternative3.png',
                width: 200,
                height: 200,
                alt: 'Image',
              },
            ],
          },
          {
            name: 'fourth',
            components: [
              {
                component: 'title',
                title: 'Noticing something <br> wrong with iPhone?',
                isSmall: true,
              },
              {
                component: 'image',
                src: '/alternative/alternative4.png',
                width: 200,
                height: 200,
                alt: 'Image',
              },
            ],
          },
          {
            name: 'fifth',
            components: [
              {
                component: 'title',
                title: 'Is your iPhone <br> storage almost full?',
                isSmall: true,
              },
              {
                component: 'image',
                src: '/alternative/preview.png',
                width: 200,
                height: 200,
                alt: 'Image',
              },
            ],
          },
          {
            name: 'sixth',
            components: [
              {
                component: 'title',
                title: 'Tired of annoying <br> pop-ups and alerts?',
                isSmall: true,
              },
              {
                component: 'image',
                src: '/alternative/preview.png',
                width: 200,
                height: 200,
                alt: 'Image',
              },
            ],
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      twoButtons: {
        hide: false,
      },
      prevButton: {
        hide: true,
      },
      progress: true,
    },
  },
  {
    slug: 'alerts-like-this-first',
    components: [
      {
        component: 'title',
        title: 'Have you seen <br> alerts like these?',
        isSmall: true,
      },
      {
        component: 'swipeElement',
        text: 'We never access your personal data. Your response only helps improve recommendations.',
        src: '/alternative/alternative5.png',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      twoButtons: {
        hide: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'alerts-like-this-second',
    components: [
      {
        component: 'title',
        title: 'Have you seen <br> alerts like these?',
        isSmall: true,
      },
      {
        component: 'swipeElement',
        text: 'We never access your personal data. Your response only helps improve recommendations.',
        src: '/alternative/alternative6.png',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      twoButtons: {
        hide: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'alerts-like-this-third',
    components: [
      {
        component: 'title',
        title: 'Have you seen <br> alerts like these?',
        isSmall: true,
      },
      {
        component: 'swipeElement',
        text: 'We never access your personal data. Your response only helps improve recommendations.',
        src: '/alternative/alternative7.png',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      twoButtons: {
        hide: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'how-work-your-phone',
    components: [
      {
        component: 'title',
        title: 'How does your phone <br> work for you?',
        isSmall: true,
      },
      {
        component: 'radioButtons',
        name: 'how-phone-work',
        items: [
          {
            title: 'Very slow',
            description: 'Often freezes and lags',
            icon: '/quiz/icons/slow.png',
          },
          {
            title: 'Sometimes slow',
            description: 'Slows down occasionally',
            icon: '/quiz/icons/sometimes-slow.png',
          },
          {
            title: 'Works okay',
            description: 'Runs fine, not perfect',
            icon: '/quiz/icons/work-okey.png',
          },
          {
            title: 'Fast',
            description: 'Smooth and responsive',
            icon: '/quiz/icons/faster.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'iphone-run-faster',
    components: [
      {
        component: 'title',
        title: 'Would you like your iPhone <br> to run faster and smoother?',
        isSmall: true,
      },
      {
        component: 'radioButtons',
        name: 'iphone-run-faster',
        items: [
          {
            title: 'Yes, definitely',
            icon: '/quiz/icons/yes.png',
          },
          {
            title: 'Maybe later',
            icon: '/quiz/icons/later.png',
          },
          {
            title: 'It’s working fine for now',
            icon: '/quiz/icons/no.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'more-storage-space',
    components: [
      {
        component: 'title',
        title: 'More Storage Space',
        isSmall: true,
      },
      {
        component: 'lottie',
        title: '+72%',
        lottie: '/alternative/chart1.json',
        text: 'extra space for all your media <br> with Clean Master',
        description: '*Based on Clean Master internal data',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: false,
      customProgress: 1,
    },
  },
  {
    slug: 'eliminate-duplicates',
    components: [
      {
        component: 'title',
        title: 'Eliminate Duplicates',
        isSmall: true,
      },
      {
        component: 'lottie',
        title: '150',
        lottie: '/alternative/chart2.json',
        text: 'duplicate contacts removed <br> on average',
        description: '*Based on Clean Master internal data',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: false,
      customProgress: 2,
    },
  },
  {
    slug: 'save-hours',
    components: [
      {
        component: 'title',
        title: 'Save Hours',
        isSmall: true,
      },
      {
        component: 'lottie',
        title: '8h',
        lottie: '/alternative/chart3.json',
        text: 'gained per month <br> with automated clean-ups',
        description: '*Based on Clean Master internal data',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: false,
      customProgress: 3,
    },
  },
  {
    slug: 'boost-performance',
    components: [
      {
        component: 'title',
        title: 'Boost Performance',
        isSmall: true,
      },
      {
        component: 'lottie',
        title: '40%',
        lottie: '/alternative/chart4.json',
        text: 'Faster response times with <br> regular clean-ups',
        description: '*Based on Clean Master internal data',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: false,
      customProgress: 4,
    },
  },
  {
    slug: 'optimize-phone',
    components: [
      {
        component: 'title',
        classes: '!mt-2',
        title: 'Optimize your <br> phone in a minute!',
        isSmall: true,
      },
      {
        component: 'description',
        description: 'An all-in-one solution for your iPhone.',
      },
      {
        component: 'radioGrid',
        name: 'optimize-phone',
        items: [
          {
            title: 'Swipe-to-clean',
            icon: '/quiz/icons/swipe.png',
          },
          {
            title: 'Secret folder',
            icon: '/quiz/icons/folder2.png',
          },
          {
            title: 'Battery boost',
            icon: '/quiz/icons/battery3.png',
          },
          {
            title: 'Photo cleanup',
            icon: '/quiz/icons/gallery2.png',
          },
          {
            title: 'Spam filter',
            icon: '/quiz/icons/spam2-2.png',
          },
          {
            title: 'Ad blocker',
            icon: '/quiz/icons/shield.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Try now',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'your-email',
    components: [
      {
        component: 'title',
        title: 'Enter your email to get <br> Clean Master app',
        isSmall: 'true',
      },
      {
        component: 'email',
        name: 'your-email',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
        text: 'Continue',
        disabledText: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'paywall',
    components: [
      {
        component: 'variationAmplitude',
        variations: [
          {
            name: '3_price_paywall',
            components: [
              {
                component: 'checkoutPaywall',
                items: [
                  {
                    name: '4-week plan',
                    solidGateProductID: '0861c564-b777-499a-88ab-6fe079a9a014',
                    originalPrice: 39.99,
                    discountedPrice: 13.99,
                    discountAmount: '26.00',
                    mostPopular: true,
                    perDay: 1.42,
                    percentDiscount: 65,
                    perDayDiscount: 0.49,
                    tag: 'Most popular',
                    text: 'Your first subscription includes an automatic discount. After the selected term, it renews at the standard price of $39.99. You can cancel anytime by contacting <a href="mailto:support@clean-master.app">support@clean-master.app</a>',
                  },
                  {
                    name: '12-week plan',
                    solidGateProductID: '8f0ef7a6-d617-47a2-b98a-a53bd4962525',
                    originalPrice: 64.99,
                    discountedPrice: 24.99,
                    discountAmount: '40.00',
                    percentDiscount: 62,
                    perDay: 0.77,
                    perDayDiscount: 0.29,
                    text: 'Your first subscription includes an automatic discount. After the selected term, it renews at the standard price of $64.99. You can cancel anytime by contacting <a href="mailto:support@clean-master.app">support@clean-master.app</a>',
                  },
                  {
                    name: '24-week plan',
                    solidGateProductID: '51fbd12d-5014-4996-9000-e060463c0225',
                    originalPrice: 99.99,
                    discountedPrice: 39.99,
                    discountAmount: '60.00',
                    percentDiscount: 60,
                    perDay: 0.59,
                    perDayDiscount: 0.23,
                    tag: 'Best value',
                    text: 'Your first subscription includes an automatic discount. After the selected term, it renews at the standard price of $99.99. You can cancel anytime by contacting <a href="mailto:support@clean-master.app">support@clean-master.app</a>',
                  },
                ],
                whatYouGetItems: [
                  'Fun swipe-to-clean interface',
                  'Smart photo suggestions',
                  'Free up storage in minutes',
                  'Compress videos',
                  'Secret Folder',
                  'Charge animations',
                  'Widgets',
                  'Ad blocker',
                ],
              },
            ],
          },
          {
            name: '1_price_paywall',
            components: [
              {
                component: 'checkoutPaywall',
                items: [
                  {
                    name: '4-week plan',
                    solidGateProductID: '0861c564-b777-499a-88ab-6fe079a9a014',
                    originalPrice: 39.99,
                    discountedPrice: 13.99,
                    discountAmount: '26.00',
                    perDay: 1.42,
                    percentDiscount: 65,
                    perDayDiscount: 0.49,
                    tag: 'Most popular',
                    text: 'Your first subscription includes an automatic discount. After the selected term, it renews at the standard price of $39.99. You can cancel anytime by contacting <a href="mailto:support@clean-master.app">support@clean-master.app</a>',
                  },
                ],
                offerItems: [
                  'Unlimited clean iPhone and storage',
                  'Unlimited get rid of useless files',
                  'Unlimited delete photos, screenshots and video',
                  'Ads Free and no limits',
                ],
              },
            ],
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'thank-you',
    components: [
      {
        component: 'thankYou',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
      },
      prevButton: {
        hide: true,
      },
      progress: false,
    },
  },
]
